import { Box } from '@mui/material';
import { SelectFormField, TextFormField } from 'components/FormFields';
import strings from 'constants/index';
import { AnyControl } from 'types/rhf';
import { normalizeMetaValues } from 'utils/normalizers.utils';
import { normalizeProperty } from 'utils/text.utils';

export const useMetaPropertyFieldGenerator = (
  metadataProperties: EntityMetaProperty[],
  control?: AnyControl,
  shouldShowFormatOnly?: boolean,
  prefixForRow?: `${string}.${number}.items.${number}`,
  isLast?: boolean,
  onPropertyChange?: (name: string, value: string | number) => void,
) => {
  if (!Array.isArray(metadataProperties) || !metadataProperties.length) {
    return (
      <Box role="status" aria-label="no-details">
        {strings.no_details}
      </Box>
    );
  }

  return metadataProperties.map(({ id, name, values, allowNonPredefinedValues, isRequired }) => {
    const normalizedName = normalizeProperty(name);
    const label =
      normalizedName.length > 24 ? `${normalizedName.substr(0, 24)}...` : normalizedName;
    const fieldName = shouldShowFormatOnly
      ? `${prefixForRow}.metadataProperties.${name}`
      : `metadataProperties.${name}`;
    if (shouldShowFormatOnly && name !== 'Format') {
      return <></>;
    }
    return allowNonPredefinedValues ? (
      <TextFormField key={id} control={control} name={fieldName} label={label} />
    ) : (
      <SelectFormField
        key={id}
        control={control}
        name={fieldName}
        label={label}
        required={shouldShowFormatOnly ? isRequired && isLast : isRequired}
        values={normalizeMetaValues(values)}
        allowEmpty
        onChange={onPropertyChange ? value => onPropertyChange(name, value) : undefined}
      />
    );
  });
};
